export const DROPS = [
  {
    id: "navratri",
    name: "The Navratri Drop",
    dateISO: "2026-10-11T00:00:00+05:30",
    dateLabel: "11 October 2026",
    tagline:
      "Nine nights, nine bowls. A vrat-friendly festive menu built on samak, kuttu, sabudana and sendha namak — fasting food that actually tastes like a celebration. Waitlist members order 48 hours before everyone else.",
    menu: [
      { n: "Samak Khichdi Bowl", d: "Barnyard millet, peanuts, curry-leaf tadka" },
      { n: "Kuttu & Roasted Veg Salad", d: "Buckwheat, pumpkin, pomegranate, lime" },
      { n: "Sabudana Peanut Crunch", d: "The classic, rebuilt with roasted veg" },
      { n: "Lauki-Coconut Cooler", d: "Bottle gourd, coconut, mint — vrat friendly" },
    ],
  },
  {
    id: "diwali",
    name: "The Diwali Drop",
    dateISO: "2026-11-01T00:00:00+05:30",
    dateLabel: "1 November 2026",
    tagline:
      "Festive mithai, rebuilt clean. No refined sugar, no refined-oil floods — dates, millets, nuts and saffron doing all the heavy lifting. Gift boxes for your people, feel-good bowls for you.",
    menu: [
      { n: "Besan-Date Laddu Box", d: "Slow-roasted besan, dates, cardamom — no refined sugar" },
      { n: "Millet Kheer Bowl", d: "Foxtail millet, saffron, pistachio, jaggery" },
      { n: "Roasted Makhana Chaat", d: "Lotus seeds, pomegranate, mint chutney drizzle" },
      { n: "Badam Saffron Mylk", d: "Almond, saffron, rose — fully plant-based" },
    ],
  },
];

export const getNextDrop = () =>
  DROPS.find((d) => new Date(d.dateISO).getTime() > Date.now()) || null;

export const getFollowingDrop = () => {
  const i = DROPS.findIndex((d) => new Date(d.dateISO).getTime() > Date.now());
  return i >= 0 ? DROPS[i + 1] || null : null;
};
